import { render, staticRenderFns } from "./EditSimpleVenue.vue?vue&type=template&id=1cf3de9f"
import script from "./EditSimpleVenue.vue?vue&type=script&lang=ts"
export * from "./EditSimpleVenue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports